import React, { FC, DetailedHTMLProps, ImgHTMLAttributes } from "react";
import environment from "Configs/environment";

type ImageProps = DetailedHTMLProps<
	ImgHTMLAttributes<HTMLImageElement>,
	HTMLImageElement
>;

const ImageView: FC<ImageProps> = (props) => {
	const { src, alt, ...restProps } = props;

	return (
		<img
			{...restProps}
			src={`${environment.standaloneAppUrl}/assets/images/${src}`}
			alt={alt}
		/>
	);
};

export default ImageView;
